import React, { PropTypes } from 'react';

const ImportModalContent = ({ head, detail, isLoading, modalType }) => {
  if (isLoading) {
    return (
      <div className="ui active dimmer">
        <div className="ui loader" />
      </div>
    );
  }

  const renderInvoiceStatus = status => {
    switch (status) {
      case 'TO_PREPARE':
        return 'A préparer';
      case 'ISSUABLE':
        return 'Emissible';
      case 'TO_ISSUE':
        return 'A émettre';
      case 'ISSUED':
        return 'En attente de réglement';
      case 'PAYED':
        return 'Réglé';
      case 'LATE':
        return 'Retard';
      case 'VERY_LATE':
        return 'Retard';
      default:
        return 'Retard';
    }
  };

  const renderEstimateStatus = status => {
    switch (status) {
      case 'TO_PREPARE':
        return 'A préparer';
      case 'ISSUED':
        return 'Généré';
      case 'ACCEPTED':
        return 'Accepté';
      case 'REFUSED':
        return 'Refusé';
      default:
        return;
    }
  };

  const renderStatus =
    modalType === 'invoice' ? renderInvoiceStatus : renderEstimateStatus;
  const renderDate = modalType === 'invoice' ? head.issue_date : head.issued_at;

  const renderLines = () => {
    if (detail.lines.length) {
      return (
        <table className="ui right floated collapsing celled table">
          <thead>
            <tr>
              <th>Libellé</th>
              <th>Quantité</th>
              <th>Prix HT</th>
              <th>Montant TVA</th>
              <th>Prix TTC (€)</th>
            </tr>
          </thead>
          <tbody>
            {detail.lines.map(line => (
              <tr
                key={
                  Math.random() % 50 + head.number + line.name + line.total_ttc
                }
              >
                <td>
                  {line.name}
                  <br />
                  <span
                    dangerouslySetInnerHTML={{ __html: line.description }}
                  />
                </td>
                <td>{line.quantity}</td>
                <td>{line.total_ht.toFixed(2)}</td>
                <td>{line.tva_amount.toFixed(2)}</td>
                <td>{line.total_ttc.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
  };

  return (
    <div className="ui grid">
      {head && (
        <div className="sixteen wide column">
          <div>
            <b>Numéro de facture: </b>
            {head.number}
          </div>
          <div>
            <b>Statut: </b>
            {renderStatus(head.status)}
          </div>
          <div>
            <b>Date d'émission: </b>
            {renderDate}
          </div>
          <div>
            <b>Total TTC: </b>
            {detail.total_ttc.toFixed(2)} €
          </div>
        </div>
      )}
      {head &&
        head.name && (
          <div className="sixteen wide centered column">{head.name}</div>
        )}
      <div
        className="sixteen wide centered column"
        dangerouslySetInnerHTML={{ __html: detail.text_before_lines }}
      />
      <div className="fourteen wide column">{renderLines()}</div>
      <div
        className="sixteen wide centered column"
        dangerouslySetInnerHTML={{ __html: detail.text_after_lines }}
      />
    </div>
  );
};

ImportModalContent.propTypes = {
  head: PropTypes.object.isRequired,
  detail: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  modalType: PropTypes.string.isRequired,
};

export default ImportModalContent;



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/imports/components/ImportModalContent.js